import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Component_overview extends PureComponent {
  render() {
    return (
      <div className="row" id="component_overview">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Component Overview</h2>
              <p>
                Components are the workhorses of the Nexoid application.
                Components range from textboxs used in data records, filters in
                search pages, pie charts in dashboards and, tables in reports.
                Different types of components are design for different types of
                user interaction. Graphing and report components are designed
                for users to view information quickly. Record components are
                designed for users to edit and view record data, search
                components designed for quick, easy filtering of records.
              </p>
              <p>
                The rest of this documentation breaks components into five
                categories "record", "information", "search", "dashboard", and
                "report". Although components are designed for specific sections
                on the application, some components can be used across different
                page types. Each component explanation contains a table showing
                the component compatibility across different page types.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="hidden-sm-xs col-md-6 darkCol ">
          <div className="contentDark"></div>
        </div>
      </div>
    );
  }
}

export default Component_overview;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Component_overview.js